export function awsCusData(data){
    return ({type:'save',data:data})
}